<template>
  <el-container class="home-layout">
    <el-header height="164px">
      <div class="banner-section">
        <div class="logo">
          <img v-if="!desensitization" :src="language === 'zh' ? logoZh : logoEn">
          <div class="language"><span :style="language === 'zh' ? '' : 'color: #3cabff;cursor: pointer;'" @click="handleSetLanguage('zh')">中文</span> | <span :style="language === 'zh' ? 'color: #3cabff;cursor: pointer;' : ''" @click="handleSetLanguage('en')">English</span></div>
        </div>
      </div>
      <navbar />
    </el-header>
    <el-main>
      <el-scrollbar>
        <div class="page-container">
          <router-view :key="this.$route.path" />
        </div>
      </el-scrollbar>
    </el-main>
  </el-container>
</template>

<script>
import Navbar from './components/Navbar'
export default {
  name: 'HomeLayout',
  components: {
    Navbar
  },
  data() {
    return {
      logoZh: require('@/assets/image/login/yxlogo_zh.png'),
      logoEn: require('@/assets/image/login/yxlogo_en.png')
    }
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
    desensitization() {
      return process.env.VUE_APP_DESENSITIZATION
    }
  },
  methods: {
    handleSetLanguage(lang) {
      if (lang !== this.language) {
        this.$i18n.locale = lang
        this.$store.dispatch('app/setLanguage', lang)
        this.$message.success(this.$t('msg.msg10'))
      }
    }
  }
}
</script>

<style lang="scss">

  .el-container.home-layout {
    height: 100%;

    .el-header {
      padding: 0;

      .banner-section {
        width: 100%;
        line-height: 116px;
        height: 116px;

        .logo {
          width: 1140px;
          margin: 0 auto;

          img {
            vertical-align:middle;
            height: 60px;
          }

          .language {
            width: 300px;
            float: right;
            text-align: center;
            color: #000;
            span {
              cursor: default;
            }
          }
        }
      }
    }

    .el-main {
      min-width: 1140px;
      height: 100%;
      padding: 0;

      .el-scrollbar {
        height: 100%;

        .el-scrollbar__wrap {
          overflow-x: hidden;

          .page-container{
            width: 1140px;
            padding: 20px;
            margin: 0 auto;
          }
        }
      }
    }
  }
</style>
